/**
 * Created by sswaminathan on 2/4/22
 * File: SectionHeaders
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { InfoIcon } from '@panwds/icons'
import { Body, Bold, Button, Tooltip } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */

const SectionHeaders = (props) => {
  const { header, showHeaderToolTip = false, toolTipContent = '' } = props
  return <div className='tw-flex tw-flex-row'>
    <Body size="sm" addClassName="tw-py-4"><Bold appearance="semibold">{header}</Bold></Body>
    {showHeaderToolTip && <Tooltip label={toolTipContent}>
      <div className='tw-flex tw-items-center'>
        <Button
          aria-label='contract-button'
          icon={<InfoIcon size='sm' />}
          appearance='clear'
          style={{ background: 'transparent' }}
        />
      </div>
    </Tooltip>}
  </div>
}

SectionHeaders.propTypes = {}
export default SectionHeaders
